import {
  Box,
  Container,
  Divider,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Link,

  useToast,
} from "@chakra-ui/react"
import { Link as RouterLink, useLocation } from "react-router-dom"
import { OneMark, WatermarkO, GoldRibbon, BridgePhoto, ribbonAccentFor, ONE_NAVY, ONE_GOLD } from "../brand/OneGroupBrand"
// import { links } from './_data'
import { useAuth } from "../../../contexts/AuthContext";
import { brandConfig } from "../../../brandConfig";
import { resetFloatingPanels } from "../../../hooks/floatingPanels";






export const FooterWithFourColumns = () => {
  const { user, isAuthenticated } = useAuth();
  const toast = useToast();
  const { pathname } = useLocation();


  // Detailed console logging of user data
  // console.log('🦶 Footer Auth State:', {
  //   isAuthenticated,
  //   userData: {
  //     id: user?.id,
  //     name: `${user?.fName} ${user?.lName}`,
  //     email: user?.email,
  //     role: user?.role,
  //     permissions: user?.permissions,
  //     isVerifiedSeller: user?.isVerifiedSeller,
  //     businessDetails: {
  //       name: user?.businessName,
  //       registrationNumber: user?.businessRegistrationNumber
  //     },
  //     addresses: {
  //       shipping: user?.shippingAddresses,
  //       billing: user?.billingAddresses
  //     },
  //     paymentDetails: user?.paymentReceivingDetails,
  //     documents: {
  //       signature: user?.encryptedSignatureIpfsUrl
  //     },
  //     dates: {
  //       created: user?.createdAt,
  //       updated: user?.updatedAt
  //     },
  //     tenantId: user?.tenantId
  //   }
  // });

  const links = [
    {
      // title: 'Company',
      links: [

        // { label: 'New Website', href: '/newwebsite' },
        // { label: 'Websites', href: '/websites' },
        // { label: 'Services', href: '/services' },
        // { label: 'New Service', href: '/services/new' },
        // { label: "Governance", href: "/governance" },

        // Add Site Map link for admins only
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "Site Map", href: "/site-map" }] : []),

        // ...(isAuthenticated && user?.permissions?.includes('SELLER') ? [{ label: 'Add Product', href: '/products/new' }] : []),
        // Add membership agreement link if signature exists
        ...(user?.encryptedSignatureIpfsUrl ? [
          {
            label: "My Signed Membership Agreement",
            href: `/membership-certificate/${user.id}`
          }
        ] : []),
        // { label: 'Careers', href: '#' },
        // { label: 'Press', href: '#' },
        // { label: 'FAQs', href: '/earn' },
      ],
    },
    {
      title: "Resources",
      links: [
        // { label: "Blog", href: "/blog" },
        // ...(isAuthenticated ? [{ label: "News", href: "/news" }] : []),
        // ...(isAuthenticated ? [{ label: 'SATS=>AUD', href: 'https://coincodex.com/convert/satoshi-sats/aud/1000/' }] : []),
        // { label: 'Case studies', href: '#' },
        // { label: 'Media Assets', href: '#' },
      ],
    },
    {
      title: "Admin",
      links: [
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "All Users (admin)", href: "/allusers" }] : []),
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "All Purchases (admin)", href: "/alluserspurchases" }] : []),
        // ...(user?.permissions?.includes("ADMIN") ? [{ label: "Node Info (admin)", href: "/nodeinfo" }] : []),
        // ...(user?.permissions?.includes('ADMIN') ? [{ label: 'BTCPay Invoices', href: '/btcpayinvoices' }] : []),
        // ...(user?.permissions?.includes('ADMIN') ? [{ label: 'All Orders', href: '/allorders' }] : []),
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "3 Day Challenge", href: "/3daychallenge" }] : []),
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "1 Lead Magnet", href: "/leadmagnet" }] : []),
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "2 Webinar Invite", href: "/relationships/free-event" }] : []),
        ...(user?.permissions?.includes("ADMIN") ? [{ label: "3 Sales Page", href: "/courses/relationships/start" }] : []),
        // ...(user?.permissions?.includes('ADMIN') ? [{ label: '2 Webinar Sales Page', href: '/relationships/free-event' }] : []),
        // ...(user?.permissions?.includes('ADMIN') ? [{ label: 'Relationship Registrations', href: '/admin/relationshipcourseregistrations' }] : []),
        // { label: 'Privacy Policy', href: '#' },
        // { label: 'Offer terms', href: '#' },
        // { label: 'License', href: '#' },
        // { label: "About", href: "/founders" },
      ],
    },
  ]

  // Debug log for links visibility
  // console.log('🔗 Footer Links State:', {
  //   isAuthenticated,
  //   userPermissions: user?.permissions,
  //   visibleLinks: links.map(group => ({
  //     title: group.title,
  //     links: group.links.map(link => link.label)
  //   }))
  // });

  // Debug log to verify signature URL condition
  // console.log('📜 Membership Agreement State:', {
  //   hasSignature: !!user?.encryptedSignatureIpfsUrl,
  //   signatureUrl: user?.encryptedSignatureIpfsUrl,
  //   userId: user?.id,
  //   membershipLink: user?.encryptedSignatureIpfsUrl ? `/membership-certificate/${user.id}` : null
  // });

  return (<>
    {/* Monica, 13 Oct 2026: her Story Bridge photo, the ribbon, the watermark O — the header's twin. */}
    <Box mt="auto" position="relative" bg={ONE_NAVY} color="whiteAlpha.900" overflow="hidden" data-testid="site-footer">
      <Box position="relative" h={{ base: "120px", md: "220px" }}>
        <BridgePhoto veil="footer" />
      </Box>
      <GoldRibbon accent={ribbonAccentFor(pathname)} />
      <WatermarkO right={{ base: "-30px", md: "4%" }} bottom={{ base: "-30px", md: "-50px" }} fontSize={{ base: "200px", md: "300px" }} opacity={0.12} />
    <Box py={10} position="relative" zIndex={1}>
      <Container as="footer" role="contentinfo" maxW="6xl">
        <VStack spacing={8}>
          {/* Main Footer Content */}
          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            gap={8}
            width="full"
          >
            {/* Brand Section */}
            <VStack align="start" spacing={4}>
              <OneMark siteName="One Group Australia" tagline="Property · Finance · Solar" />
              <Text fontSize="md" color="whiteAlpha.800" maxW="300px">
                {brandConfig.description}
              </Text>
            </VStack>

            {/* Links Section */}
            <VStack align="start" spacing={4}>
              <Text fontSize="sm" fontWeight="600" color={ONE_GOLD} letterSpacing="2px" textTransform="uppercase">
                Links
              </Text>
              <VStack align="start" spacing={2}>
                {links.slice(0, 2).map((group) =>
                  group.links.map((link, idx) => (
                    <Link
                      key={idx}
                      as={RouterLink}
                      to={link.href}
                      color="whiteAlpha.900"
                      fontSize="md"
                      fontWeight="400"
                      transition="all 0.2s ease"
                      _hover={{
                        color: "#c5a06a",
                        textDecoration: "none"
                      }}
                    >
                      {link.label}
                    </Link>
                  ))
                )}
              </VStack>
            </VStack>

            {/* Contact Section */}
            <VStack align="start" spacing={4}>
              <Text fontSize="sm" fontWeight="600" color={ONE_GOLD} letterSpacing="2px" textTransform="uppercase">
                Contact
              </Text>
              <VStack align="start" spacing={2}>
                <Text fontSize="sm" color="whiteAlpha.800">
                  {brandConfig.contact.businessType}
                </Text>
                <Text fontSize="sm" color="whiteAlpha.800">
                  {brandConfig.contact.industry}
                </Text>
                {brandConfig.contact.email && (
                  <Link
                    href={`mailto:${brandConfig.contact.email}`}
                    fontSize="sm"
                    color="whiteAlpha.900"
                    _hover={{
                      color: "#c5a06a",
                      textDecoration: "none"
                    }}
                  >
                    {brandConfig.contact.email}
                  </Link>
                )}
              </VStack>
            </VStack>
          </SimpleGrid>

          {/* Bottom Bar */}
          <Divider borderColor="whiteAlpha.300" />

          <HStack justify="space-between" w="full" flexWrap="wrap" spacing={4}>
            <Text fontSize="sm" color="whiteAlpha.800">
              &copy; {new Date().getFullYear()} {brandConfig.siteName}. All rights reserved.
            </Text>

            <HStack spacing={6} flexWrap="wrap">
              <Link
                as={RouterLink}
                to="/privacy"
                fontSize="sm"
                color="whiteAlpha.900"
                _hover={{
                  color: "#c5a06a",
                  textDecoration: "none"
                }}
              >
                Privacy
              </Link>
              <Link
                as={RouterLink}
                to="/terms"
                fontSize="sm"
                color="whiteAlpha.900"
                _hover={{
                  color: "#c5a06a",
                  textDecoration: "none"
                }}
              >
                Terms
              </Link>
              {/* The floating-launcher failsafe. It lives HERE — in the footer, on every layout
                  page — and not inside any launcher's own menu, because a reset you can only
                  reach by opening the launcher is useless exactly when the launcher is the thing
                  that's lost. Dispatch-only by contract: each floater's own listener clears its
                  own storage keys, so this file never has to know which floaters exist.
                  vault/how-to/draggable-floating-launchers.md § The reset failsafe. */}
              {isAuthenticated && (
                <Link
                  as="button"
                  fontSize="sm"
                  color="whiteAlpha.900"
                  _hover={{
                    color: "#c5a06a",
                    textDecoration: "none"
                  }}
                  onClick={() => {
                    resetFloatingPanels();
                    toast({
                      title: "Panels reset",
                      description: "Every floating button is back where it started, and any you'd hidden are showing again.",
                      status: "success",
                      duration: 3000,
                      isClosable: true,
                    });
                  }}
                >
                  ↻ Reset floating panels
                </Link>
              )}
              <Link
                as={RouterLink}
                to="/contact"
                fontSize="sm"
                color="whiteAlpha.900"
                _hover={{
                  color: "#c5a06a",
                  textDecoration: "none"
                }}
              >
                Contact
              </Link>
            </HStack>
          </HStack>
        </VStack>
      </Container>
    </Box>
    </Box>

  </>
  )
}